import type { MutationHookOptions } from '@apollo/client'
import {
  CreateTrainingClassDocument,
  CreateTrainingClassMutation,
  CreateTrainingClassMutationVariables,
  GroupsTableDocument,
  TrainingClassesDocument,
  TrainingClassesFilterDatesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  CreateTrainingClassMutation,
  CreateTrainingClassMutationVariables
>

export const useCreateTrainingClass = (options?: Options) => {
  const [createTrainingClass, { loading }] = useMutation(CreateTrainingClassDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.createTrainingsTrainingClass,
    awaitRefetchQueries: true,
    refetchQueries: [
      TrainingClassesDocument,
      GroupsTableDocument,
      TrainingClassesFilterDatesDocument,
    ],
  })

  return {
    loading,
    create(variables: CreateTrainingClassMutationVariables) {
      return createTrainingClass({
        variables,
      })
    },
  }
}
